import {
  AllSortMethods 
} from "@/common/utils/AllSortMethods"

export const getFiltersFromPath = (
  pathname,
  aggregations,
  allCategories,
  sortFields
) => {
  const filters = new Map()

  const pathArr = pathname.split("/")

  // 过滤掉分页参数
  const findIndex = pathArr.indexOf("p")

  if (findIndex > -1 && /^\d+$/.test(pathArr[findIndex + 1])) {
    pathArr.splice(findIndex, 2)
  }

  // 过滤掉排序，目录
  const filteredPathArr = pathArr.filter((temp) => {
    return (
      temp !== "" &&
            allCategories.findIndex((item) => item.url_key === temp) === -1 &&
            sortFields.findIndex((item) => item.value === temp) === -1
    )
  })

  filteredPathArr.forEach((subPath) => {
    const findAggregation = aggregations.find((temp) => temp.rewrite === subPath)
    let group
    const items = new Set()

    if (findAggregation) {
      group = findAggregation.code
      items.add(findAggregation.option_id)
      filters.set(group, items)
    } else if (/^\d+\-\d+$/g.test(subPath)) {
      group = "price"
      items.add({
        title: subPath.replace("-", "_"),
        value: subPath.replace("-", "_"),
      })
      filters.set(group, items)
    }
  })

  return filters
}

export const getPageFromPath = (pathname) => {
  const pathArr = pathname.split("/")

  const findIndex = pathArr.indexOf("p")

  if (findIndex > -1 && /^\d+$/.test(pathArr[findIndex + 1])) {
    return pathArr[findIndex + 1]
  }

  return 1
}

export const getSortFromSearchParams = (searchParams) => {
  const sortQuery = searchParams["sort_by"]

  const findSort = AllSortMethods.find((temp) => temp.sortQuery === sortQuery)

  const sortState = findSort || {
    sortId: "sortItem.position",
    sortText: "Featured",
    sortAttribute: "position",
    sortDirection: "ASC",
    sortQuery: "featured",
  }

  return sortState
}
